import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  label: {
    description: 'Footer align label',
    defaultMessage: 'Footer Align',
    id: 'Nx7l93',
  },
  afterLastRow: {
    description: 'After last row footer align option',
    defaultMessage: 'After Last Row',
    id: 'B28907',
  },
  pageBottom: {
    description: 'Page bottom footer align option',
    defaultMessage: 'Page Bottom',
    id: 'N7ZLDs',
  },
});
